module.exports = __webpack_public_path__ + "img/character07_static.8cf75750.png";